import { toast } from "react-toastify";
import { _AbstractAccount, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { useEffect, useState } from "react";
import { PrintJson } from "../../../../../../modules/theme/Component/PrintJson";
import { DocTypeConstantsEditor } from "../../../../../../modules/GestionTerceros/AbstractAccount/Editor/DocTypeConstants.editor";
import { InputDate } from "../../../../../../modules/theme/Input/InputDate";
import { SelectSiteID } from "../../../../../../modules/admin/configuracion/SiteID/SelectSiteID";
import { GenderTypeConstantsEditor } from "../../../../../../modules/GestionTerceros/AbstractAccount/Editor/GenderTypeConstants.editor";
import { BloodTypeConstantsEditor } from "../../../../../../modules/GestionTerceros/AbstractAccount/Editor/BloodTypeConstants.editor";
import { RhTypeConstantsEditor } from "../../../../../../modules/GestionTerceros/AbstractAccount/Editor/RhTypeConstants.editor";
import { BasicButton } from "../../../../../../modules/theme/Component/BasicButton";
import { CardTaps } from "../../../../../../modules/theme/Component/CardTaps";
import { ThirdBankingAccount } from "../../../../../../modules/Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/ThirdBankingAccount";

interface componentData {
    idAccount: number;
}

export const AccountDataViewerEditor = ({ idAccount }: componentData) => {

    const { instance, setBean, bean } = useDataBean(_AbstractAccount)

    useEffect(() => {
        if (idAccount) {
            getLista(idAccount);
        }
    }, [idAccount])

    const getLista = (idAccount: number) => {
        instance.getAccountbyID(idAccount).then(
            (resp) => {
                setBean(resp);
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const update = () => {
        instance.updateAbstractAccount(bean).then(
            (resp) => {
                getLista(resp.Nit);
            }
        ).catch(err => { toast.error(err) })
    }

    const taps = [
        { id: 0, name: 'Información Básica', disable: false },
        { id: 1, name: 'Cuentas Bancarias', disable: false },
    ];

    const [indexTap, setIndexTap] = useState(0);


    return (
        <>
            <CardTaps index={indexTap} updateIndex={setIndexTap} taps={taps}>
                {indexTap == 0 &&
                    <div className="row">
                        <div className="col-6">
                            <label>No Documento</label>
                            <input type="number" className='form-control' value={bean.Nit} disabled />
                        </div>
                        <div className="col-6">
                            <label>Digito de Verificacion</label>
                            <input type="number" className='form-control' value={bean.VerificationDigit} disabled />
                        </div>
                        <div className="col-6">
                            <DocTypeConstantsEditor label='Tipo Documento' idSelector={bean.DocType} onChange={(e) => { setBean({ ...bean, "DocType": e }) }} />
                        </div>
                        <div className="col-6">
                            <label>Fecha Expedición</label>
                            <InputDate name='FechaExpedicion' value={bean.IDExpeditionDate} setDate={(e) => { setBean({ ...bean, "IDExpeditionDate": e }) }} />
                        </div>
                        <div className="col-6">
                            <SelectSiteID label='Lugar de Expedición' edit onChange={(e) => { setBean({ ...bean, "IDResidenceZoneType": e.IDLn }) }} idLnSite={bean.IDResidenceZoneType} />
                        </div>
                        <div className="col-6">
                            <label>Primer Nombre</label>
                            <input type="text" className='form-control' name='Name1' value={bean.Name1} onChange={(e) => { setBean({ ...bean, Name1: e.target.value }) }} />
                        </div>
                        <div className="col-6">
                            <label>Segundo Nombre</label>
                            <input type="text" className='form-control' name='Name2' value={bean.Name2} onChange={(e) => { setBean({ ...bean, Name2: e.target.value }) }} />
                        </div>
                        <div className="col-6">
                            <label>Primer Apellido</label>
                            <input type="text" className='form-control' name='Surname1' value={bean.Surname1} onChange={(e) => { setBean({ ...bean, Surname1: e.target.value }) }} />
                        </div>
                        <div className="col-6">
                            <label>Segundo Apellido</label>
                            <input type="text" className='form-control' name='Surname2' value={bean.Surname2} onChange={(e) => { setBean({ ...bean, Surname2: e.target.value }) }} />
                        </div>
                        <div className="col-6">
                            <label>Titulo</label>
                            <input type="text" className='form-control' name='CommercialName' value={bean.CommercialName} onChange={(e) => { setBean({ ...bean, CommercialName: e.target.value }) }} />
                        </div>
                        <div className="col-6">
                            <label>Fecha Nacimiento</label>
                            <InputDate name='Fecha Nacimiento' value={bean.BornDate} setDate={(e) => { setBean({ ...bean, "BornDate": e }) }} />
                        </div>
                        <div className="col-6">
                            <GenderTypeConstantsEditor label='Genero' idSelector={bean.GenType} onChange={(e) => { setBean({ ...bean, "GenType": e }) }} />
                        </div>
                        <div className="col-6">
                            <BloodTypeConstantsEditor label='Tipo de Sangre' idSelector={bean.BloodType} onChange={(e) => { setBean({ ...bean, "BloodType": e }) }} />
                        </div>
                        <div className="col-6">
                            <RhTypeConstantsEditor label='Tipo de RH' idSelector={bean.RhType} onChange={(e) => { setBean({ ...bean, "RhType": e }) }} />
                        </div>
                        <div className="col-6">
                            <SelectSiteID label='Lugar de Nacimiento' edit onChange={(e) => { setBean({ ...bean, "IDBornSiteLn": e.IDLn }) }} idLnSite={bean.IDBornSiteLn} />
                        </div>
                        <div className="col-6">
                            <SelectSiteID label='Lugar de Residencia' edit onChange={(e) => { setBean({ ...bean, "IDResidenceSiteLn": e.IDLn }) }} idLnSite={bean.IDResidenceSiteLn} />
                        </div>
                        <div className="col-6">
                            <label>Dirección</label>
                            <input type="text" className='form-control' name='Address' value={bean.Address} onChange={(e) => { setBean({ ...bean, Address: e.target.value }) }} />
                        </div>
                        <div className="col-6">
                            <label>Telefono</label>
                            <input type="text" className='form-control' name='Tel' value={bean.Tel} onChange={(e) => { setBean({ ...bean, Tel: e.target.value }) }} />
                        </div>
                        <div className="col-6">
                            <label>Correo Electrónico</label>
                            <input type="text" className='form-control' name='eMail' value={bean.eMail} onChange={(e) => { setBean({ ...bean, eMail: e.target.value }) }} />
                        </div>
                        <div className="col-6">
                            <label>Correo Institucional</label>
                            <input type="text" className='form-control' name='eMailCorporate' value={bean.eMailCorporate} onChange={(e) => { setBean({ ...bean, eMailCorporate: e.target.value }) }} />
                        </div>
                        <div className="col-md-12">
                            <BasicButton useMargin eventClick={() => { update() }} icon="ri-save-line" children={`Guardar`} />
                        </div>
                    </div>
                }
                {indexTap == 1 &&
                    <div className="row">
                        <div className="col-md-12">
                            <ThirdBankingAccount canModify isModal idAccount={_single.getAccountID()} />
                        </div>
                    </div>
                }
            </CardTaps>

        </>
    )
}